import React, { useState, useEffect, useContext } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import Select from "react-select";
import { FilterContext } from "../context/FilterContext";
import Button from "@mui/material/Button";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";

const placeholder = "Select";
const selectText = "Select All";
const deselectText = "Deselect All";

function Filter(props) {
  const { setOrg, setTech, setDemo, setState, setOwnership } =
    useContext(FilterContext);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [options, setOptions] = useState([]);
  const [id, setId] = useState();

  const customStyles = {
    menu: (provided, state) => ({
      ...provided,
      //width: state.selectProps.width,
    }),
    option: (provided, state) => ({
      ...provided,
      //backgroundColor: state.value === selectText ? '#377AE3' : 'white',
      color: state.value === selectText ? "white" : "black",
      textAlign: state.value === selectText ? "center" : "left",
    }),
  };

  useEffect(() => {
    if (props.selected) {
      setSelectedOptions(props.selected);
    }
  }, [props.selected]);

  useEffect(() => {
    setOptions(props.options);
    setId(props.id);
  }, [props.options, props.id]);

  useEffect(() => {
    resetFilters();
  }, [props.reset]);

  const resetFilters = () => {
    setSelectedOptions([]);
    setFilterById([]);
  };

  const updateSelectText = (text) => {
    options.forEach((option) => {
      const label = option.label;
      if (option.value === selectText && label !== text) {
        option.label = text;
      }
    });
  };

  const modifyUrl = (modified_query) => {
    const queryString = `?events=${modified_query}`;
    const newUrl =
      window.location.protocol +
      "//" +
      window.location.host +
      window.location.pathname +
      queryString;
    window.history.pushState({ path: newUrl }, "", newUrl);
  };

  const onSelection = (e) => {
    const selectAll = e.filter((option) => option.value === selectText);
    if (props.filter_type === "orgs") {
      let modified_query = e.map((item) => item.value).join(",");
      modifyUrl(modified_query);
    }

    if (selectAll.length === 0) {
      setSelectedOptions(e);
      setFilterById(e);
      if (e.length === options.length - 1) {
        updateSelectText(deselectText);
      } else {
        updateSelectText(selectText);
      }
    } else {
      if (props.filter_type === "orgs") {
        modifyUrl("");
      }
      options.forEach((option) => {
        if (option.value === selectText) {
          const label = option.label;
          option.label = label === deselectText ? selectText : deselectText;
          if (label === selectText) {
            const selectedItems = options.filter((o) => o.value !== selectText);
            setSelectedOptions(selectedItems);
            setFilterById(selectedItems);
          } else {
            setSelectedOptions([]);
            setFilterById([]);
          }
        }
      });
    }
  };

  const setFilterById = (options) => {
    switch (id) {
      case "org":
        setOrg(options);
        break;
      case "tech":
        setTech(options);
        break;
      case "demo":
        setDemo(options);
        break;
      case "state":
        setState(options);
        break;
      case "ownership":
        setOwnership(options);
        break;
    }
  };

  const HtmlTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: "#f5f5f9",
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#f5f5f9",
      color: "rgba(0, 0, 0, 0.87)",
      maxWidth: 220,
      fontSize: theme.typography.pxToRem(12),
      border: "1px solid #dadde9",
    },
  }));

  const renderTooltip = () => {
    if (props.info !== "") {
      return (
        <HtmlTooltip
          title={
            <React.Fragment>
              <Typography color="inherit">{props.info}</Typography>
            </React.Fragment>
          }
          arrow
        >
          <Button>
            <FontAwesomeIcon icon={faInfoCircle} />
          </Button>
        </HtmlTooltip>
      );
    }
  };

  return (
    <div className="filter">
      <div className="filter-title">
        <h3>
          {props.title} {renderTooltip()}
        </h3>
      </div>
      <div className="filter-options">
          <Select
            hideSelectedOptions={true}
            className="muli-select-filter"
            placeholder={placeholder}
            onChange={(e) => onSelection(e)}
            value={props.filter_type === "orgs" ? props.selected : selectedOptions}
            isMulti
            options={options}
            styles={customStyles}
          />
      </div>
    </div>
  );
}

export default Filter;
